import React from 'react';
import { connect } from 'react-redux'
import DistribucionLimitesEmpresa from './DistribucionLimitesEmpresa.jsx';

//Connect entre el componente y las props y actions.
const DistribucionLimitesEmpresaContainer = connect()(DistribucionLimitesEmpresa);

export default DistribucionLimitesEmpresaContainer;
